import React, { Component } from 'react'
import styled from 'styled-components'
import axios from 'axios'
import { API_URL } from '../constants'
import moment from 'moment'
import { get } from 'lodash'
import { PageWrapper, XXLText, Header, Card, FlexWrapper, XLText } from '../components'

class ViewSingleNotifications extends Component {
  state = { result: {}, usersData: [] }
  async componentDidMount() {
    try {
      const { data } = await axios.get(`${API_URL}/Notifications/${get(this.props, 'match.params.id', '')}`)
      const userIds = JSON.parse(data.userIds)
      const newData = await Promise.all(
        userIds.map(async item => {
          const d = await this.getUserById(item)
          return d
        })
      )
      this.setState({ result: data, usersData: newData })
      // console.log('data', data)
      // console.log('newData', newData)
    } catch (error) {
      console.log(error)
    }
  }

  getUserById = async id => {
    if (id) {
      try {
        const { data } = await axios.get(`${API_URL}/users/${id}`)
        return data
      } catch (error) {
        console.log('ERROR', error)
      }
    }
    return
  }

  render() {
    const { result, usersData } = this.state
    return (
      <React.Fragment>
        <Header
          icon="arrowBack"
          title="View Notifications"
          onClickBack={() => this.props.history.goBack()}
          backgroundColor="#124b5f"
          color="#fff"
        />
        <PageWrapper viewPadding="0" height={'calc(100% - 10px)'} modifyPadding="0" style={{ marginTop: 60 }}>
          <Card padding="8px" margin="10px 0 0">
            <FlexWrapper>
              <XXLText color="#124b5f">Date: {moment(get(result.createdAt)).format('DD MMM YYYY HH:mm:ss')}</XXLText>
              <XXLText color="#000">Title: {result.title}</XXLText>
              <XXLText color="#000">Message: {result.message}</XXLText>
              <XLText color="#000">Users: </XLText>
              {usersData.map(item => (
                <React.Fragment>
                  <XXLText color="#124b5f">Name: {item.name}</XXLText>
                  <XXLText color="#124b5f">Email: {item.email}</XXLText>
                </React.Fragment>
              ))}
            </FlexWrapper>
          </Card>
        </PageWrapper>
      </React.Fragment>
    )
  }
}

export default ViewSingleNotifications



// WEBPACK FOOTER //
// ./src/pages/ViewSingleNotifications.js